import Typography from '@mui/material/Typography'
import { SxProps } from '@mui/material/styles'
import React, { RefObject } from 'react'

const htmlContentStyle: SxProps = {
  '& > p': {
    marginBlockStart: 0,
  },
  '& > p:last-child': {
    marginBlockEnd: 0,
  },
}

type HtmlContentWithMentionsProps = {
  htmlContent: string
  sx?: SxProps
  textRef?: RefObject<HTMLSpanElement>
}

const HtmlContent: React.FC<HtmlContentWithMentionsProps> = ({ htmlContent, sx, textRef }) => {
  return (
    <Typography
      component="span"
      className="fr-view"
      ref={textRef}
      sx={{ ...htmlContentStyle, ...sx }}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  )
}

export default HtmlContent
